import { CircularProgress } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import TextError from "../../../Components/HealthInsFormikComponent/TextError";
import * as Yup from "yup";
import axios from "axios";
import '../CSS/StarHealthKYC.css'

function DocUploadGenRef({ formik }) {
  const isForm60required = formik.values["isForm60required"];

  const handleFileUpload = async (e, setFieldValue, field, size) => {
    const file = e.target.files[0];
    console.log(file);
    const defaultSize = size ? 1.5 : 3;
    if (file?.size / 1024 / 1024 <= defaultSize) {
      const fileType = file.type.split("/")[1];
      const defaultType = ["pdf", "jpeg", "jpg", "tiff"];

      if (defaultType.includes(fileType)) setFieldValue(field, file);
      else {
        e.target.value = "";
        alert(
          "Unknown file type, File type must be one of [ pdf , jpeg , jpg , tiff]"
        );
      }
    } else {
      alert(`File size must be of ${defaultSize} or less`);
      e.target.value = "";
    }
  };

  return (
    <>
      <div className="form-container ">
        <div className="d-flex justify-content-center">
          <h3>Document Upload</h3>
        </div>
        <label htmlFor="idProof fw-bold">Identity or Address Proof</label>
        <div
          className="form-group mb-4 "
          style={{ border: "3px solid rgba(0, 0, 0.01, 0.05)" }}
        >
          <Field
            as="select"
            name="idorAddressProofSelect"
            id="idorAddressProofSelect"
            className={
              formik.touched.idorAddressProofSelect &&
              formik.errors.idorAddressProofSelect
                ? "errorStyle form-control bg-white"
                : !formik.errors.idorAddressProofSelect &&
                  formik.touched.idorAddressProofSelect
                ? "successField form-control bg-white"
                : "form-control bg-white"
            }
          >
            <option value="">Select Options</option>
            <option value="a">Upload in Single Document</option>
            <option value="b">Upload front and back Seperately</option>
          </Field>
          {formik.values["idorAddressProofSelect"] === "a" ? (
            <div>
              <input
                type="file"
                name="idOrAddressProofDocument"
                id="idOrAddressProofDocument"
                // className={
                //     formik.touched.idProofDoc && formik.errors.idProofDoc
                //       ? "errorStyle form-control bg-white"
                //       : !formik.errors.Doc && formik.touched.idProofDoc
                //       ? "successField form-control bg-white"
                //       : "form-control bg-white"
                //   }
                onChange={(e) =>
                  handleFileUpload(
                    e,
                    formik.setFieldValue,
                    "idOrAddressProofDocument"
                  )
                }
              ></input>
              <label htmlFor="file-input">
                {formik.values["idOrAddressProofDocument"] ? formik.values["idOrAddressProofDocument"]?.name : "No file chosen"}
              </label>
              <ErrorMessage
                name="idOrAddressProofDocument"
                component={TextError}
              />
            </div>
          ) : formik.values["idorAddressProofSelect"] === "b" ? (
            <div>
              <div className="form-group mb-4 ">
                <label htmlFor="idProof fw-bold">Upload FrontSide</label>
                <input
                  type="file"
                  name="idOrAddressProofDocumentFrontSide"
                  id="idOrAddressProofDocumentFrontSide"
                  // className={
                  //     formik.touched.idProofDoc && formik.errors.idProofDoc
                  //       ? "errorStyle form-control bg-white"
                  //       : !formik.errors.Doc && formik.touched.idProofDoc
                  //       ? "successField form-control bg-white"
                  //       : "form-control bg-white"
                  //   }
                  onChange={(e) =>
                    handleFileUpload(
                      e,
                      formik.setFieldValue,
                      "idOrAddressProofDocumentFrontSide",
                      1.5
                    )
                  }
                ></input>
                <label htmlFor="file-input">
                {formik.values["idOrAddressProofDocumentFrontSide"] ? formik.values["idOrAddressProofDocumentFrontSide"]?.name : "No file chosen"}
              </label>
                <ErrorMessage
                  name="idOrAddressProofDocumentFrontSide"
                  component={TextError}
                />
              </div>
              <div>
                <label htmlFor="idProof fw-bold">Upload BackSide</label>
                <input
                  type="file"
                  name="idOrAddressProofDocumentBackSide"
                  id="idOrAddressProofDocumentBackSide"
                  // className={
                  //     formik.touched.idProofDoc && formik.errors.idProofDoc
                  //       ? "errorStyle form-control bg-white"
                  //       : !formik.errors.Doc && formik.touched.idProofDoc
                  //       ? "successField form-control bg-white"
                  //       : "form-control bg-white"
                  //   }
                  onChange={(e) =>
                    handleFileUpload(
                      e,
                      formik.setFieldValue,
                      "idOrAddressProofDocumentBackSide",
                      1.5
                    )
                  }
                ></input>
                <label htmlFor="file-input">
                {formik.values["idOrAddressProofDocumentBackSide"] ? formik.values["idOrAddressProofDocumentBackSide"]?.name : "No file chosen"}
              </label>
                <ErrorMessage
                  name="idOrAddressProofDocumentBackSide"
                  component={TextError}
                />
              </div>
            </div>
          ) : null}
          {/* <ErrorMessage name="idProofDoc" component={TextError} /> */}
          <ErrorMessage name="idorAddressProofSelect" component={TextError} />
        </div>

        <div className="form-group mb-4 ">
          <label htmlFor="adProof fw-bold">Upload Your Photograph</label>
          <input
            type="file"
            name="photographDoc"
            id="photographDoc"
            onChange={(e) =>
              handleFileUpload(e, formik.setFieldValue, "photographDoc")
            }
          ></input>
          {/* <ErrorMessage name="adProof" component={TextError} /> */}
          <label htmlFor="file-input">
                {formik.values["photographDoc"] ? formik.values["photographDoc"]?.name : "No file chosen"}
              </label>
          <ErrorMessage name="photographDoc" component={TextError} />
        </div>
        {isForm60required ? (
          <div className="form-group mb-4 ">
            <label htmlFor="adProof fw-bold">Upload Form60 Document</label>
            <input
              type="file"
              name="form60Document"
              id="form60Document"
              onChange={(e) =>
                handleFileUpload(e, formik.setFieldValue, "form60Document")
              }
            ></input>
            {/* <ErrorMessage name="adProof" component={TextError} /> */}
            <label htmlFor="file-input">
                {formik.values["form60Document"] ? formik.values["form60Document"]?.name : "No file chosen"}
              </label>
            <ErrorMessage name="form60Document" component={TextError} />
          </div>
        ) : null}
      </div>
    </>
  );
}

export default DocUploadGenRef;
